"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paddingPropTypes = exports.paddingDefaultProps = undefined;

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _propTypes3 = require("../../constants/propTypes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var paddingDefaultProps = exports.paddingDefaultProps = {};
var paddingPropTypes = exports.paddingPropTypes = {
  all: _propTypes3.isValidSize,
  bottom: _propTypes3.isValidSize,
  children: _propTypes2.default.node.isRequired,
  horizontal: _propTypes3.isValidSize,
  left: _propTypes3.isValidSize,
  right: _propTypes3.isValidSize,
  top: _propTypes3.isValidSize,
  vertical: _propTypes3.isValidSize
};